export default __webpack_public_path__ + "static/media/noData.cc873e5a.svg";